class Group {
    get key() {
        return `${this.name}-${this.subtitle}`;
    }

    constructor(name, displayOrder, subtitle) {
        [this.name, this.displayOrder, this.subtitle] = [name, displayOrder, subtitle];
        
        this.fields = [];
        this.isExpanded = true;
    }

    clone() {
        const clone = new Group(this.name, this.displayOrder, this.subtitle);
        clone.fields = [...this.fields];

        return clone;
    }
}

export default Group;